import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02ed7efa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "top-entities-list"
}
const _hoisted_2 = { class: "top-entities-list__rank" }
const _hoisted_3 = { class: "top-entities-list__name" }
const _hoisted_4 = { class: "top-entities-list__value" }
const _hoisted_5 = {
  key: 1,
  class: "top-entities-list__footer"
}

import { computed, ref, watch } from 'vue';
import DashboardWidget from '@/components/dashboard/DashboardWidget.vue';
import { useDashboardQuery } from '@/core/hooks/useDashboardQuery';
import { useDashboardStore } from '@/core/hooks/useDashboardStore';
import { DashboardService } from '@/core/services/Dashboard.service';
import { getDefaultTopEntityFilters } from '@/core/constants/dashboard.constants';
import type { TopEntitiesData, TopEntityItem } from '@/core/interfaces/Dashboard';

const previewLimit = 5;
const expandedLimit = 20;


export default /*#__PURE__*/_defineComponent({
  __name: 'TopEntitiesTable',
  props: {
    compact: { type: Boolean }
  },
  setup(__props: any) {



const { scope } = useDashboardStore();
const showAll = ref(false);
const entityType = ref<'unit' | 'warehouse' | 'material'>('unit');
const metric = ref<
  'ending_amount' | 'import_amount' | 'export_amount' | 'alert_count'
>('ending_amount');

watch(
  scope,
  (nextScope) => {
    const defaults = getDefaultTopEntityFilters(nextScope);
    entityType.value = defaults.entityType;
    metric.value = defaults.metric;
    showAll.value = false;
  },
  { immediate: true }
);

const {
  data,
  isFetching,
  isError,
  isEmpty,
  isStale,
  generatedAt,
  refetch,
} = useDashboardQuery<TopEntitiesData>(
  'top-entities',
  scope,
  (s) =>
    DashboardService.getTopEntities(s, {
      entityType: entityType.value,
      metric: metric.value,
      limit: expandedLimit,
    }),
  {
    filters: computed(() => ({
      entity_type: entityType.value,
      metric: metric.value,
      limit: expandedLimit,
    })),
  }
);

const allItems = computed<TopEntityItem[]>(() => data.value?.items ?? []);

const visibleItems = computed(() =>
  showAll.value ? allItems.value : allItems.value.slice(0, previewLimit)
);

const hasMore = computed(
  () => !showAll.value && allItems.value.length > previewLimit
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DashboardWidget, {
    title: "Top đơn vị theo giá trị tồn kho",
    compact: _ctx.compact,
    loading: _unref(isFetching),
    error: _unref(isError),
    empty: _unref(isEmpty),
    "is-stale": _unref(isStale),
    "generated-at": _unref(generatedAt),
    "has-cached-content": Boolean(_unref(data)),
    "empty-text": "Chưa có dữ liệu top đơn vị.",
    onRetry: _unref(refetch)
  }, {
    default: _withCtx(() => [
      (visibleItems.value.length)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleItems.value, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.id,
                class: "top-entities-list__item"
              }, [
                _createElementVNode("span", _hoisted_2, _toDisplayString(item.rank), 1),
                _createElementVNode("span", _hoisted_3, _toDisplayString(item.name), 1),
                _createElementVNode("span", _hoisted_4, _toDisplayString(item.formattedValue), 1)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (hasMore.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("button", {
              type: "button",
              class: "top-entities-list__more",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showAll.value = true))
            }, " Xem tất cả > ")
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["compact", "loading", "error", "empty", "is-stale", "generated-at", "has-cached-content", "onRetry"]))
}
}

})